import React from 'react';
interface BonusMockupProps {
  number: number;
  icon: string;
  coverColor: string;
}
export function BonusMockup({
  number,
  icon,
  coverColor
}: BonusMockupProps) {
  return <div className="relative w-44 h-60 mx-auto" data-id="element-16">
      {/* Drop shadow base */}
      <div className="absolute inset-0 translate-x-1 translate-y-2 bg-black/10 rounded-xl blur-md" data-id="element-17"></div>

      {/* Book cover */}
      <div className="relative w-full h-full rounded-xl shadow-xl overflow-hidden flex flex-col justify-between p-6" style={{
      backgroundColor: coverColor
    }} data-id="element-18">
        {/* Spine highlight */}
        <div className="absolute left-0 top-0 bottom-0 w-3 bg-black/10" data-id="element-19"></div>
        <div className="absolute left-3 top-0 bottom-0 w-px bg-white/20" data-id="element-20"></div>

        <div className="text-3xl" data-id="element-21">{icon}</div>

        <div data-id="element-22">
          <div className="text-white text-2xl font-black mb-4" data-id="element-23">
            Bonus {number}
          </div>
          <div className="h-px bg-white/40 mb-4" data-id="element-24"></div>
          <div className="text-white/80 text-xs font-bold tracking-widest" data-id="element-25">
            STRETCHING 360™
          </div>
        </div>
      </div>
    </div>;
}